import React, { useEffect, useState } from 'react';
import { listLegal, updateLegal } from '../lib/api';
import { toast } from 'sonner';
import { FileText, Save, Loader2 } from 'lucide-react';

export default function OwnerLegalEditor() {
  const [docs, setDocs] = useState([]);
  const [active, setActive] = useState(null);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const all = await listLegal(); setDocs(all); if (all[0]) select(all[0]); }
      catch { toast.error('Failed to load'); }
      finally { setLoading(false); }
    })();
  }, []);

  const select = (d) => { setActive(d.slug); setTitle(d.title || ''); setContent(d.content || ''); };

  const save = async () => {
    if (!active) return;
    setSaving(true);
    try {
      const updated = await updateLegal(active, content, title);
      setDocs(ds => ds.map(d => d.slug === active ? updated : d));
      toast.success('Saved');
    } catch (err) { toast.error(err?.response?.data?.detail || 'Save failed'); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="flex items-center gap-2 text-white/60 py-10"><Loader2 className="w-5 h-5 animate-spin" /> Loading…</div>;

  return (
    <div className="grid md:grid-cols-[220px_1fr] gap-6" data-testid="owner-legal-tab">
      <aside className="card-shell p-3 h-max">
        {docs.map(d => (
          <button key={d.slug} onClick={() => select(d)}
            className={`w-full text-left px-3 py-2 rounded-lg text-[13.5px] flex items-center gap-2 ${active === d.slug ? 'bg-white/10 text-white' : 'text-white/65 hover:bg-white/[0.04]'}`}
            data-testid={`legal-tab-${d.slug}`}>
            <FileText className="w-4 h-4" /> {d.title}
          </button>
        ))}
      </aside>
      <div className="card-shell p-5">
        <input value={title} onChange={e => setTitle(e.target.value)} className="input-field w-full text-[18px] font-display" data-testid="legal-title-input" />
        <textarea value={content} onChange={e => setContent(e.target.value)} rows={18}
          className="mt-3 input-field w-full font-mono text-[13px] leading-relaxed" data-testid="legal-content-input" />
        <div className="mt-3 flex items-center justify-end">
          <button disabled={saving} onClick={save} className="btn-primary disabled:opacity-50" data-testid="legal-save-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Save
          </button>
        </div>
      </div>
    </div>
  );
}
